<template>

    <button 
        v-if="type == 'button' || type == 'submit'" 
        :type="type"
        :class="getButtonClass()"
        @click="$emit('click', $event)"
    >
        <slot />
    </button>

    <a
        v-else-if="type == 'link'" 
        :href="href"
        :target="(blankTarget == true)?'blank':null"
        :class="getButtonClass()"
        @click="$emit('click', $event)"
    >
        <slot />
    </a>

</template>

<script setup>
const emit      = defineEmits([
    'click'
])

const props     = defineProps({
    
    class     : {
        type        : [ String, Array ],
        default     : [],
    },

    type      : {
        type        : String,
        default     : "button"
    },

    href     : {
        type        : String,
        default     : null,
    },

    to     : {
        type        : Object,
        default     : null,
    },

    blankTarget   : {
        type        : Boolean,
        default     : false,
    },

    variant   : {
        type        : String,
        default     : 'primary',
    },

})

const getButtonClass        = () => {

    let classes     = []

    classes.push(props.class)

    if (props.variant === 'builder') {
        classes.push('j-btn-builder')
    } else {
        classes.push('j-btn-primary')
    }

    return classes;
}
</script>
